<template>
  <div class="filter-list-image-item pos-relative">
    <!-- @click="setCurrentImage(item)" -->
    <div
      class="filter-list-image-container"
      @mouseover="toggleImgOverlay(true)"
      @mouseleave="toggleImgOverlay(false)"
      @showCaptureImageDialog="showCaptureImageDialog(true)"
    >
      <img
        alt=""
        v-if="item.data != null"
        :src="item.data"
        class="filter-list-image-item__img"
      />
      <img
        alt=""
        v-else
        :src="prefixServerImgPath(`${item.examinationID}/${item.file}`)"
        class="filter-list-image-item__img"
      />
      <div class="filter-list-image-item-actions-overlay" :class="showImgOverlay ? '' : 'd-none'">
        <v-btn
          flat
          icon
          dark
          small
          @click.stop="downloadImg(`${item.examinationID}/${item.file}`)"
          class="hover-btn"
        >
          <v-icon>cloud_download</v-icon>
        </v-btn>
        <v-btn 
          flat 
          small
          icon 
          dark 
          @click.stop="$emit('deleteImg', item.id)"
          class="hover-btn"
          v-if="!allowEdit"
        >
          <v-icon>delete_outline</v-icon>
        </v-btn>
        <select-icon
          :value="item.findingID"
          :items="findingOptionList"
          @change="findingChange"
          v-if="allowEdit"
        >
          <template slot-scope="props">
            <v-btn
              icon
              flat
              small
              dark
              v-on="props.on"
              class="hover-btn"
            >
            <img width="16" height="12" src="~@/assets/icons/subtract.png" />
            </v-btn>
          </template>
        </select-icon>
        <select-icon
          :value="item.landmarkID"
          :items="landmarkOptionList"
          @change="landmarkChange"
          v-if="allowEdit"
        >
          <template slot-scope="props">
            <v-btn 
              icon 
              flat 
              small 
              v-on="props.on"
              class="hover-btn"
            >
              <v-icon small >arrow_downward</v-icon>
            </v-btn>
          </template>
        </select-icon>
      </div>
      <v-btn
        icon
        flat             
        small
        class="action-btn print"
        v-if="statusIcon === 'check'"
        @click.stop="$emit('imgStatusChange')"
      >
        <v-icon color="#10B981" class="status-icon">
          {{ statusIcon }}
        </v-icon>
      </v-btn>
      
    </div>

    <div :class="['filter-list-image-actions', statusIcon]">
      <div class="left pic-number">P{{ item.imgSerial }}</div>
      <div 
        class="finding-name "
        :class="{ 'finding-name-offset': allowEdit }"
      >
        {{ findingName }}{{ findingName !=='' && landmarkText !='' ?' , ':'' }}{{ landmarkText }}
      </div>
      
    </div>
    
    <!-- <div class="tag yellow accent-4" v-if="item.tag && item.tag.length > 0">
      {{ item.tag.toUpperCase() }}
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import common from '@/utils/common'
import SelectIcon from './SelectIcon'
import { findMatchI18n } from '@/utils/findMatchI18n'
export default {
  name: 'ScreenshotImageItem',
  components: {
    SelectIcon,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    findingSelectItems: {
      type: Array,
      required: true,
    },
    landmarkSelectItems: {
      type: Array,
      required: true,
    },
    number: {
      type: Number,
      required: true,
    },
    hideLandmark: {
      type: Boolean,
      required: false,
      default: false
    },
    allowEdit: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      showImgOverlay: false,
      showFindingSelectOptions: null,
      showLandmarkSelectOptions: null,
    }
  },
  computed: {
    ...mapGetters('examinations', [
      'getExaminationData',
      'getExaminationTypeList',
      'getPatient',
      'getQuestionsList',
      'getFindingNameMap',
    ]),
    findingOptionList() {
      let _tmpArr = []
      for(let i = 0; i < this.findingSelectItems.length; i++) {
        _tmpArr.push({ value: this.findingSelectItems[i].value, text: findMatchI18n(this.findingSelectItems[i].text) })
      }
      return _tmpArr
    },
    landmarkOptionList() {
      let _tmpArr = []
      for(let i = 0; i < this.landmarkSelectItems.length; i++) {
        _tmpArr.push({ value: this.landmarkSelectItems[i].value, text: findMatchI18n(this.landmarkSelectItems[i].text) })
      }
      return _tmpArr
    },
    getFindings() {
      return this.getExaminationData ? this.getExaminationData.findings : null;
    },
    findingName() {
      let _arr = {}
      // console.log(this.getFindings)
      const findingMap = this.getFindings.find(row => row.id === this.item.findingID)
      if (findingMap) {
        const findingMapId = findingMap.questions.finding.value
        return findMatchI18n(this.getFindingNameMap[findingMapId])
      }
      return ''
    },
    findingIndex() {
      if (this.item) {
        const findingID = Number.parseInt(this.item.findingID)
        const index = this.getExaminationData.findings.findIndex(({ id }) => id === findingID)
        return index + 1
      }
      return 0
    },
    landmarkText() {
      if (this.item.landmarkID != 0 && this.landmarkSelectItems.length) {
        const landmark = this.landmarkSelectItems.find(e => e.value === this.item.landmarkID)
        if (landmark) {
          return findMatchI18n(landmark.text.replace(/(\Wof\Wcolon|\Wcolon)$/ig, ''))
        }
      }
      return ''
    },
    statusIcon() {
      return this.item?.status == 0 ? 'print' : 'check'
    },
  },
  methods: {
    toggleImgOverlay(boolean) {
      this.showImgOverlay = boolean
    },
    setCurrentImage() {
      void 0
      this.$emit('setCurrentImage', this.item)
    },
    toDataURL(url) {
      return fetch(url)
        .then(response => {
          return response.blob()
        })
        .then(blob => {
          return URL.createObjectURL(blob)
        })
    },
    async downloadImg(path) {
      const url = this.prefixServerImgPath(path)
      const filename = `${common.fileRule(
        this.getExaminationData,
        this.getExaminationTypeList,
        this.getPatient,
      )}_${url.replace(/^.*[\\\/]/, '')}`
      const a = document.createElement('a')
      a.href = await this.toDataURL(url)
      a.download = filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    prefixServerImgPath(path) {
      return `/api/upload/image/${path}`
    },
    findingChange(v) {
      this.$emit('findingChange', v)
    },
    landmarkChange(v) {
      this.$emit('landmarkChange', v)
    },
  },
}
</script>

<style lang="scss">
.filter-group-container .filter-list-image-actions {
  .left.pic-number {
    margin: 5px;
    max-width: 40px;
    height: calc(100% - 10px);
    text-align: center;
    padding-top: 3px;
    color: black;
    font-size: 14px;
    border: 1px solid white;
    width: 55px;
    border-radius: 20%;
    background-color: #ffffff;
  }

  .v-btn--icon.v-btn--small {
    margin: 3px;
  }
}

.filter-list-image-item {
  position: relative;
  font-size: 0;

  .tag {
    color: #44362d;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    padding: 2px;
  }

  &__img {
    width: 100%;
    border-radius: 10px 10px 0 0;
  }
}
</style>
<style scoped>
.finding-name{
  font-size:small;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #ffffff;
}
.finding-name-offset{
  width: 73px;
}
.action-btn::before{
  background: transparent !important;
  display: none !important;
}
.action-btn{
  background-color: rgba(222,222,222, 0.4) ; 
  border-radius: 50%;
  position: absolute;
  right: 0px;
  width:32px;
  height:32px;
}
.action-btn.finding{
  position: absolute;
  right: 24px;
}
.action-btn.landmark{
  position: absolute;
  right: 0px;
}
.status-icon{
  background-color: rgba(255,255,255, 1); 
  border-radius: 50%;
}
.hover-btn{
  margin-left: 4px;
  margin-right: 4px;
}
</style>